import React, { useCallback, useMemo } from 'react';
import { ConfigureWorkflowBaseProps } from 'apps/sigma2-ui/src/components/workflows/types';
import { WriteBackToFountainStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import { WriteBackToFountainAuthMethod } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import { WriteBackToFountainPlaceToWrite } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import { ConfigureWriteBackFountainPlaceToWrite } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackFountainPlaceToWrite';
import { ConfigureWriteBackFountainAuthMethod } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackFountainAuthMethod';

export interface ConfigureWriteBackFountainStrategyProps
  extends ConfigureWorkflowBaseProps {
  strategy: WriteBackToFountainStrategy | null;

  updateStrategy: (strategy: WriteBackToFountainStrategy | null) => void;

  allowedPlacesToWriteTypes: WriteBackToFountainPlaceToWrite['type'][];
}

export const ConfigureWriteBackFountainStrategy = ({
  strategy,
  updateStrategy,
  listSecretsPattern,
  organizationId,
  listDataSetsPattern,
  allowedPlacesToWriteTypes,
}: ConfigureWriteBackFountainStrategyProps) => {
  const updateAuthMethod = useCallback(
    (authMethod: WriteBackToFountainAuthMethod | null) => {
      updateStrategy({
        type: 'fountain',
        ...strategy,
        authMethod: authMethod ?? undefined,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedAuthMethod = useMemo(
    () => strategy?.authMethod ?? null,
    [strategy?.authMethod],
  );

  const updatePlacesToWrite = useCallback(
    (placesToWrite: WriteBackToFountainPlaceToWrite[]) => {
      updateStrategy({
        type: 'fountain',
        ...strategy,
        placesToWrite,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedPlacesToWrite = useMemo(
    () => strategy?.placesToWrite ?? [],
    [strategy?.placesToWrite],
  );

  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <h2 className="text-xl font-semibold">Configure Fountain Strategy</h2>
      <p className="text-gray-600">
        Configure the strategy for writing back the hiring readiness score to
        Fountain.
      </p>
      <ConfigureWriteBackFountainAuthMethod
        authMethod={selectedAuthMethod}
        updateAuthMethod={updateAuthMethod}
        listSecretsPattern={listSecretsPattern}
        organizationId={organizationId}
        listDataSetsPattern={listDataSetsPattern}
      />
      <ConfigureWriteBackFountainPlaceToWrite
        placesToWrite={selectedPlacesToWrite}
        updatePlacesToWrite={updatePlacesToWrite}
        listSecretsPattern={listSecretsPattern}
        organizationId={organizationId}
        listDataSetsPattern={listDataSetsPattern}
        allowedPlacesToWriteTypes={allowedPlacesToWriteTypes}
      />
    </div>
  );
};
